import { render, staticRenderFns } from "./SearchToggle.vue?vue&type=template&id=5b97e6d5"
import script from "./SearchToggle.vue?vue&type=script&lang=js"
export * from "./SearchToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports